import styled from "styled-components";
import {
  ERROR,
  GREY_LIGHT,
  GREY_DARK,
  GREY_LIGHTEST,
  GREY_MEDIUM_LIGHT,
  GREY_MEDIUM,
  GREY_MEDIUM_DARK,
  MAX_DESKTOP_WIDTH,
} from "../constants/cssVars";

export const SHORT_WIDTH = 300;

export const ErrorText = styled.label`
  margin-bottom: 2px;
  font-size: 0.9em;
  display: block;
  color: ${ERROR};
  font-style: italic;
`;

export const LabelledInput = styled.div`
  & > label {
    color: ${GREY_DARK};
    margin-bottom: 2px;
    padding-bottom: ${({ smallerText }) => (smallerText ? "1" : "0")}px;
    font-size: ${({ smallerText }) => (smallerText ? "0.8" : "0.9")}em;
    display: inline-block;
    ${({ error }) => (error ? `color: ${ERROR};` : "")}
  }
  & > div > input,
  & > div > select {
    background-color: ${({ disabled }) => (disabled ? GREY_LIGHT : "#fff")};
    color: ${({ disabled }) => (disabled ? GREY_MEDIUM_DARK : "#000")};
    width: ${({ short }) => (short ? `${SHORT_WIDTH}px` : "100%")};
  }
  margin: 5px 0px;
  margin-bottom: 15px;
`;

export const InputWrapper = styled.div`
  margin: 4px 0px;
  margin-bottom: 2px;
`;

export const DeleteIcon = styled.img`
  width: 15px;
  height: 15px;
`;

export const InfoIcon = styled.img`
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-left: 5px;
  position: relative;
  top: 2px;
`;

export const FileUploadWrapper = styled.div`
  padding: 6px 6px;
  border-radius: 4px;
  border: 1px solid ${GREY_MEDIUM};
  background-color: ${GREY_LIGHT};
`;

export const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 13px 0px;
  margin-right: 20px;
`;

export const radioInputStyle = {
  backgroundColor: GREY_LIGHTEST,
  padding: "3px 8px",
  borderRadius: "10px",
  marginTop: "8px",
  border: `1px solid ${GREY_MEDIUM_LIGHT}`,
  display: "block",
};

export const CheckboxWrapper = styled.label`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  ${({ wrapperStyle }) => wrapperStyle};
  margin: 10px 0px;
  margin-right: 15px;
`;

export const CheckboxGroupWrapper = styled.div`
  background-color: ${GREY_LIGHTEST};
  padding: 3px 8px;
  border-radius: 10px;
  margin-top: 8px;
  border: 1px solid ${GREY_MEDIUM_LIGHT};
`;

export const MultiFieldLine = styled.div`
  width: 100%;
  width: calc(100% - 15px);
  display: grid;
  grid-column-gap: 15px;
  grid-template-columns: ${({ columns }) => columns};
  @media only screen and (max-width: ${MAX_DESKTOP_WIDTH}px) {
    display: flex;
    flex-direction: column;
    > div {
      max-width: 400px;
    }
  }
`;

export const MultiDatePickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const DeleteBtn = styled.button`
  background: transparent;
  border: none;
`;
